import React from "react";
import TitleText from "./utils/TitleText";
import Card from "./utils/Card";

const services = [
	{
		image:
			"https://leadgrowdevelop.com/wp-content/uploads/2025/01/image-12.png",
		title: "IT Consulting & Strategy",
		subtext:
			"Expert advice and strategic guidance to optimize your IT infrastructure and digital operations.",
	},
	{
		image:
			"https://media.licdn.com/dms/image/v2/D4D12AQGcPVX_NRt6wg/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1684708829034?e=2147483647&v=beta&t=_KOMwIrhp42Oi8I9xex7o7YxkAKq5M8mjqf4Y-xkhCI",
		title: "Cloud Infrastructure & DevOps",
		subtext:
			"Robust cloud solutions and automated DevOps pipelines that enhance scalability, optimize deployments, and improve operational efficiency for modern businesses",
	},
	{
		image:
			"https://easy-peasy.ai/cdn-cgi/image/quality=80,format=auto,width=700/https://media.easy-peasy.ai/14286e2e-9e36-4cc1-a5ca-e8c43bf6c07a/ee29a101-7511-41ad-b259-aac407770f26.png",
		title: "Network & Systems Integration",
		subtext:
			"Connecting your infrastructure, systems, and applications into a unified, secure, and high-performance network environment.",
	},
	{
		image:
			"https://media.licdn.com/dms/image/v2/D5612AQHGWKxA69POTw/article-cover_image-shrink_600_2000/article-cover_image-shrink_600_2000/0/1732519039964?e=2147483647&v=beta&t=Bc_uHRo-wYPAbzqgiJNrNKUwsurDQcqk4TIR9Z_C_Bk",
		title: "IT Support & Managed Services",
		subtext:
			"Proactive IT support and fully managed services to keep your business systems secure, efficient, and always available.",
	},
	{
		image:
			"https://reroom.ai/_next/image?url=https%3A%2F%2Freroom.s3.amazonaws.com%2Fassets%2Flanding%2Fhero-compare-original-1.jpg&w=3840&q=75",
		title: "Interior Decoration & Design",
		subtext:
			"Creative, functional, and modern interior solutions that transform workspaces into productive and visually inspiring environments.",
	},
	{
		image: "https://miro.medium.com/v2/resize:fit:1400/0*1w0_B9PTqfJWByad",
		title: "Security & Compliance Solutions",
		subtext:
			"Comprehensive security frameworks and compliance services designed to protect your data, systems, and business operations.",
	},
	{
		image:
			"https://media.licdn.com/dms/image/v2/D4E12AQElrPd3VTa73A/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1707243731271?e=2147483647&v=beta&t=mqvAIkNViel8oZYbYh5kH77lMK1lhtrlqABFgDN0JgA",
		title: "Web Development & Digital Marketing",
		subtext:
			"Custom website design, development, and digital marketing strategies that drive visibility, engagement, and online growth.",
	},
	{
		image:
			"https://media.licdn.com/dms/image/v2/D5612AQEHke0xajdAmA/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1737453099247?e=2147483647&v=beta&t=ZrAE_tfknxK0DfbYR-5zrIo0qYvl1HY6gY9GMElTR_g",
		title: "Training & Capacity Building",
		subtext:
			"Empowering individuals and organizations with the skills, tools, and knowledge required to thrive in today’s digital world.",
	},
	{
		image:
			"https://img.freepik.com/premium-photo/ecommerce-banner_1281315-2598.jpg",
		title: "E-commerce Solutions",
		subtext:
			"Scalable, secure, and user-friendly e-commerce platforms tailored to help businesses expand, sell, and succeed online.",
	},
];

const Services = () => (
	<section className="py-20 bg-slate-300" id="services">
		<div className="flex items-center flex-col px-4">
			<TitleText title="Our Services" />
			<p className="text-slate-900 mb-10 mt-5 font-semibold text-center max-w-3xl">
				At Diamond Heirs Limited, we offer a comprehensive range of services
				designed to meet the diverse needs of our clients.
			</p>

			<ul className="grid md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-6 list-disc pl-6 text-slate-700">
				{services.map((service, index) => (
					<Card
						key={index}
						image={service.image}
						title={service.title}
						subtext={service.subtext}
					/>
				))}
			</ul>
		</div>
	</section>
);

export default Services;
